import { Signature, PenNib, CalendarBlank, TextT, CaretDown, CheckSquare, RadioButton, Textbox } from "@phosphor-icons/react";

export const RECIPIENT_COLORS = ["#0052FF", "#2A9D8F", "#F4A261", "#7C3AED", "#E63946", "#0891B2"];

export const FIELD_TYPES = {
  signature: { key: "signature", label: "Signature", icon: Signature, w: 0.26, h: 0.055 },
  initials: { key: "initials", label: "Initials", icon: PenNib, w: 0.12, h: 0.05 },
  date: { key: "date", label: "Date Signed", icon: CalendarBlank, w: 0.17, h: 0.032 },
  text: { key: "text", label: "Text", icon: TextT, w: 0.22, h: 0.038 },
  custom: { key: "custom", label: "Custom", icon: Textbox, w: 0.24, h: 0.05 },
  dropdown: { key: "dropdown", label: "Dropdown", icon: CaretDown, w: 0.24, h: 0.11, options: ["Option 1", "Option 2"] },
  checkbox: { key: "checkbox", label: "Checkbox", icon: CheckSquare, w: 0.035, h: 0.028 },
  radio: { key: "radio", label: "Radio", icon: RadioButton, w: 0.22, h: 0.1, options: ["Option 1", "Option 2"] },
};

export const HAS_OPTIONS = ["dropdown", "radio"];

export const FIELD_LIST = Object.values(FIELD_TYPES);
